import { getClinicAuthToken, getUserAuthToken } from '@/assets/js/auth'

import HttpRequest from './HttpRequest'

class DataClinicProvider extends HttpRequest {
  updateDataClinic (id, payload) {
    this.setHeader(getClinicAuthToken())
    return this.patch(`/v1/branchs/${id}`, payload)
  }

  getDataClinicByid (id) {
    this.setHeader(getClinicAuthToken())
    return this.get(`/v1/branchs/${id}`)
  }

  updateDataMainClinic (id, payload) {
    this.setHeader(getUserAuthToken())
    return this.patch(`/v1/clinics/${id}`, payload)
  }

  getDataClinicMainByid (id) {
    this.setHeader(getUserAuthToken())
    return this.get(`/v1/clinics/${id}`)
  }
}

export default DataClinicProvider
